<template>
    <div>
        <div class="tabulation-title">
            <h5>
                <v-icon>label_outline</v-icon> Photo de votre agence
            </h5>
        </div>

        <v-alert type="info"
                 text
                 v-if="!disabled"
                 class="mt-5 mb-5 form-container mr-auto ml-auto"
                 border="right"
                 colored-border>
            <div><b>Une photo</b> personnelle du(des) dirigeant(s), ou de votre structure, éviter les paysages</div>
        </v-alert>

        <div class="pl-5 pr-5 mt-5">
            <div class="d-flex justify-start medias-box flex-wrap">
                <v-card v-for="(media, index) in providerData.medias"
                        class="mb-5 media-card"
                        v-if="(media.is_404 === undefined || !media.is_404) && media.is_image">
                    <v-img height="200px"
                           width="300px"
                           class="v-media"
                           :src="(media.thumbnail_url !== null) ? media.thumbnail_url : media.url"
                           @click="showMedia(media)">
                        <div class="media-logo" v-if="media.source !== undefined && media.source !== null && media.source.type !== 'APIDAE'">
                            <img :src="'/images/logo-' + media.source.type + '.jpg'">
                        </div>
                    </v-img>

                    <div class="clear-toolbar">
                        <v-icon size="26px" @click="deleteMedia(index)">clear</v-icon>
                    </div>

                    <v-card-text>
                        <v-text-field label="Titre" v-model="media.name" outlined class="mb-3"></v-text-field>
                        <v-text-field label="Copyright" v-model="media.copyright" outlined></v-text-field>
                    </v-card-text>
                </v-card>

                <div style="width: 300px" class="mb-5 media-card" v-show="providerData.medias.length <= 1">
                    <div ref="dashboardContainer"></div>
                    <div ref="dashboardProgress"></div>
                </div>
            </div>
        </div>

        <v-dialog v-model="showFullScreen" content-class="fullscreen-image" style="z-index: 2600">
            <div @click="hideMedia">
                <v-img v-if="selectedMedia !== null"
                       contain
                       :src="(selectedMedia.url !== undefined && selectedMedia.url !== null) ? selectedMedia.url : selectedMedia.origin_url"
                       :lazy-src="selectedMedia.thumbnail_url"
                       class="ml-auto"
                       max-height="100vh"
                       max-width="100vw">
                </v-img>
            </div>
        </v-dialog>

        <confirm ref="confirm" :hide-next="true"></confirm>
    </div>
</template>

<script>
import Uppy from "@uppy/core"
import Dashboard from "@uppy/dashboard"
import ProgressBar from "@uppy/progress-bar"
import AwsS3 from "@uppy/aws-s3"
import Confirm from "../tools/Confirm"
import French from "@uppy/locales/lib/fr_FR"
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import '@uppy/progress-bar/dist/style.css'
import {mapState} from "vuex"

export default {
    name: "AuraMedia",
    components: {Confirm},
    props: ['provider-data', 'disabled'],
    data() {
        return {
            selectedMedia: null,
            showFullScreen: false,
            uppy: null,
            addMod: false
        }
    },
    methods: {
        showMedia(media) {
            if(!this.addMod) {
                this.selectedMedia  = media
                this.showFullScreen = true
            }
        },
        hideMedia() {
            this.selectedMedia  = null
            this.showFullScreen = false
        },
        deleteMedia(index) {
            if(!this.hideNextModal) {
                this.$refs.confirm.open('Attention',
                    'Êtes-vous sûr de vouloir supprimer cette photo ?',
                    { color: 'red' }).
                then((confirm) => {
                    if (confirm) {
                        this.providerData.medias.splice(index, 1)
                    }
                })
            } else {
                this.providerData.medias.splice(index, 1)
            }
        },
        pushMedia(originUrl, thumbnailUrl, source = null, temp = true) {
            let media = {
                thumbnail_url: thumbnailUrl,
                name: null,
                copyright: null,
                temp: temp,
                origin_url: originUrl,
                url: originUrl,
                source: source,
                is_image: true
            }

            this.providerData.medias = [media]
        },
        dec2hex (dec) {
            return dec < 10
                ? '0' + String(dec)
                : dec.toString(16)
        },
        generateId (len) {
            let arr = new Uint8Array((len || 40) / 2)
            window.crypto.getRandomValues(arr)
            return Array.from(arr, this.dec2hex).join('')
        }
    },
    computed: {
        ...mapState('web_form', ['hideNextModal'])
    },
    mounted() {
        if(!this.disabled) {
            let self = this

            this.uppy = Uppy({
                debug: true,
                autoProceed: true,
                locale: French,
                restrictions: {
                    maxFileSize: 10485760,
                    maxNumberOfFiles: 1,
                    allowedFileTypes: ['image/png', 'image/jpeg', 'image/gif', 'image/bmp']
                }
            }).use(Dashboard, {
                hideUploadButton: true,
                inline: true,
                height: 337,
                width: 'auto',
                target: this.$refs.dashboardContainer,
                replaceTargetContent: true,
                showProgressDetails: true,
                browserBackButtonClose: true,
                theme: 'light',
                locale: {
                    strings: {
                        dropPaste: 'Déposer les fichiers ici depuis votre %{browse}',
                        browse: 'ordinateur ou smartphone',
                    }
                },
                proudlyDisplayPoweredByUppy: false,
                showSelectedFiles: false
            }).use(ProgressBar, {
                target: this.$refs.dashboardProgress,
                hideAfterFinish: false
            }).use(AwsS3, {
                companionUrl: process.env.VUE_APP_API_URL + '/api/companion',
                getUploadParameters (file) {
                    return fetch(process.env.VUE_APP_API_URL + '/api/companion', {
                        method: 'post',
                        headers: {
                            accept: 'application/json',
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            filename: self.generateId(20) + '.' + file.extension,
                            contentType: file.type,
                            origin_filename: file.name
                        })
                    }).then((response) => {
                        return response.json()
                    }).then((data) => {
                        return {
                            method: data.method,
                            url: data.url,
                            fields: data.fields,
                            headers: data.headers
                        }
                    })
                }
            })

            this.uppy.on('complete', (event) => {
                if(event.successful !== undefined) {
                    event.successful.forEach(result => {
                        let path = result.response.body.location
                        this.pushMedia(path, path)
                    })
                }

                this.uppy.reset()
            })
        }
    }
}
</script>